import React, { Fragment } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { FormControlLabel, Typography } from '@mui/material';

import './Night.scss';

type NightProps = {
  handleCheckboxChange: React.ChangeEventHandler<HTMLInputElement>;
  isNightChecked: boolean;
};

const Night = ({ handleCheckboxChange, isNightChecked }: NightProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleCheckboxChange(e);
  };

  return (
    <Fragment>
      <FormControlLabel
        control={<Checkbox checked={isNightChecked} onChange={handleChange} />}
        label={
          <Typography
            component="span"
            variant="body1"
            style={{ color: '#333333' }}
          >
            Night Time Choghadiya?
          </Typography>
        }
      />
    </Fragment>
  );
};

export default Night;
